<template>
  <div class="col s12">
    <p></p>
    <div class="col s12 m12 l9" id="middle" >
      <div id='puzzleBoard' style="width: auto; height: auto;" :class="classboard"></div>
    </div>    
    <div class="col s12 m12 l3" style="text-align: center; padding-left: 20px;" v-if="puzzle.createby">
      <div class="">
        <blockquote><h6 v-if="puzzle.type.startsWith('Practica')" id='eval' class="flat-text-header hello" style="text-align: center"></h6></blockquote>
        <div id="pgnComment" style="display: none;"></div>
        <!-- <h5 class="flat-text-header">{{ $t("puzzles.createBy") }} </h5>
        {{puzzle.createby}}
        <h5 class="flat-text-header">{{ $t("puzzles.date") }}</h5>
        {{puzzle.created | moment 'DD/MM/YYYY, h:mm:ss a'}}-->
        <h5 class="flat-text-header">{{ $t("puzzles.played") }}: {{ $t("puzzles.color." + turn) }}</h5>
        <div v-if="!puzzle.type.startsWith('Practica')">
          <h6 class="flat-text-header">{{ $t("puzzles.movs") }}</h6>
          <blockquote class="chip pulse">{{numMoves}}</blockquote>
        </div>
        <!-- <h6 class="flat-text-header">Tiempo</h6>-->
        <blockquote class="chip pulse purple darken-4" style="text-align: center; font-size: small;overflow: hidden; text-overflow:ellipsis;color:white">
                <span class="" style="text-align: center;">Faltan <b>{{ times | timeBoard}}</b> de {{timeMove | timeBoard }}</span>
        </blockquote>
        <div v-if="mate && numMoves===0 && !puzzle.type.startsWith('Practica')" style="text-align: center;">
          <span>
            <h3>{{ $t("puzzles.wins") }}</h3>      
          </span>
          <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="nextPuzzle()">
            Siguiente
          </a>
        </div>
        <div v-else>
          <span>
            <h3>{{ resultPractica }}</h3>      
          </span>
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="nextPuzzle()">
              Siguiente
            </a>
          </div>
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" data-tooltip="Insertar comentarios en la posición (IA)"  @click="insertComments();">
              Ayuda
            </a>
          </div>
          <div class="row">
            <a v-if="retrocederPosible" class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" data-tooltip="Retroceder un movimiento"  @click="retroceder();">
              Retroceder
            </a>
          </div>
        </div>
        <div v-if="!mate && numMoves===0 && !puzzle.type.startsWith('Practica')">
          <h3>{{ $t("puzzles.lost") }}</h3>
          <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4"
             @click="reintent()"
          >
            {{ $t("puzzles.reintent") }}
          </a>
        </div>
        <div slot="actions" v-if="!puzzle.type.startsWith('Practica')">
          Difultad:  <blockquote class="chip pulse">{{ 100 - Math.round(puzzle.corrects * 100 / puzzle.intents) }}%</blockquote>
          <!-- <blockquote class="chip pulse"><span>Aciertos ({{puzzle.corrects}})</span></blockquote>
          <blockquote class="chip pulse"><span>Intentos ({{puzzle.intents}})</span></blockquote>-->
        </div>
         
        <div v-if="numMoves !== 0 && !puzzle.type.startsWith('Practica')">
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="pista()">pista</a>
          </div>
          <div class="row">
            <a class="btn waves-effect waves-light col s12 m12 l12 purple darken-4" @click="resultado()">resultado</a>
          </div>
        </div>
  </div>
</div>
</div>
</template>


<script>
// import Chessground from 'chessground'
import Chess from 'chess.js'
import toast from 'vue-material-components'
import openai from '../../services/openaiutils'
// import Garbochess from '../../services/garbochess.min.js'
import UserService from '../../services/user'
import EngineGame from '../../services/enginegame.min.js'
import PuzzleService from '../../services/puzzle'
import Store from '../../services/lstorage'
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
window.pgnBoardBase = 0
var timesColor = 0

export default {
  name: 'puzzleChess',
  props: {
    puzzle: {
      type: Object
    },
    classboard: {
      type: String
    },
    titlefen: {
      type: String
    },
    nextPuzzle: {
      type: Function,
      required: false,
      'default': function () {
        return false
      }
    }
  },
  data () {
    return {
      mate: false,
      numMoves: 1000,
      timeMove: 120,
      handMoves: 0,
      userColor: 'white',
      user: UserService.user,
      ground: 1,
      turn: 'white',
      stockfish: this.ChessEngine(), // EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'}),
      chessFind: new Chess(),
      chess: new Chess(),
      chessPgn: new Chess(),
      fen: '',
      stylesBoard: stylesBoard,
      times: 120,
      retrocederPosible: false,
      resultPractica: '',
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      audio: null
    }
  },
  mixins: [
    toast
  ],
  methods: {
    ChessEngine () {
      return EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
    },
    onResize (event) {
      document.body.dispatchEvent(new window.Event('chessground.resize'))
    },
    chessToDests (chess) {
      var dests = {}
      chess.SQUARES.forEach(function (s) {
        var ms = chess.moves({square: s, verbose: true})
        if (ms.length) dests[s] = ms.map(function (m) { return m.to })
      })
      return dests
    },
    retroceder () {
      if (this.retrocederPosible) {
        // window.alert('retroceder')
        this.chess.undo()
        this.chess.undo()
        setTimeout(function () {
          this.pcMove(this.chess.fen())
          this.loadPuzzle(this.chess.fen())
        }.bind(this), 200)
      }
    },
    resolvePuzzle (parms) {
      PuzzleService.resolve(this, parms).then(function (response) {
        // window.alert('bien')
      }, function (response) {
        // window.alert('mal')
      })
    },
    moveToSan (move) {
      // this.chess.load_pgn(this.pgn)
      this.chess.load(this.fen)
      // window.alert(this.fen)
      const moves = this.chess.moves({ verbose: true }) // Obtener movimientos posibles en formato detallado
      // window.alert(JSON.stringify(moves) + move.to + move.from)
      const foundMove = moves.find(m => m.from === move.from && m.to === move.to)
      if (!foundMove) {
        // window.alert('null')
        console.error('foundMove null')
        return null
      }
      const translationMap = {
        K: 'R', // King -> Rey
        Q: 'D', // Queen -> Dama
        R: 'T', // Rook -> Torre
        B: 'A', // Bishop -> Alfil
        N: 'C'  // Knight -> Caballo
      }
      // window.alert(foundMove.san)
      // Función para traducir los códigos de piezas dentro de un comentario
      function translateCodesInComment (comment) {
        return comment.replace(/\b([KQRBN])x?([a-h][1-8])\b/g, (match, p1, p2) => {
          // Reemplaza la letra de la pieza, pero deja las coordenadas de la jugada intactas
          return translationMap[p1] + (match.includes('x') ? 'x' : '') + p2
        })
      }
      var ret = translateCodesInComment(foundMove.san)
      // window.alert(ret)*
      // var ret = foundMove.san
      return ret
    },
    getIndexFromFen (fen) {
      const fenParts = fen.split(' ')
      if (fenParts.length !== 6) {
        return -1
      }
      /* const position = fenParts[0]
      const turn = fenParts[1]
      const castling = fenParts[2]
      const enPassant = fenParts[3]
      const halfMoveClock = fenParts[4]*/
      const fullMoveNumber = fenParts[5]
      return fullMoveNumber // Retorna -1 si no se encuentra la posición
    },
    getTurnFromFen (fen) {
      const fenParts = fen.split(' ')
      if (fenParts.length !== 6) {
        return -1
      }
      /* const position = fenParts[0]*/
      const turn = fenParts[1]
      /* const castling = fenParts[2]
      const enPassant = fenParts[3]
      const halfMoveClock = fenParts[4]
      const fullMoveNumber = fenParts[5]*/
      return turn // Retorna -1 si no se encuentra la posición
    },
    translatePieceCodesInComments (pgnText) {
      // Mapa de traducción para las piezas de ajedrez
      const translationMap = {
        K: 'R', // King -> Rey
        Q: 'D', // Queen -> Dama
        R: 'T', // Rook -> Torre
        B: 'A', // Bishop -> Alfil
        N: 'C'  // Knight -> Caballo
      }
      // Expresión regular para encontrar comentarios en {}
      const commentRegex = /(\{[^}]*\})|(;[^\n]*)/g
      // Función para traducir los códigos de piezas dentro de un comentario
      function translateCodesInComment (comment) {
        return comment.replace(/\b([KQRBN])x?([a-h][1-8])\b/g, (match, p1, p2) => {
          // Reemplaza la letra de la pieza, pero deja las coordenadas de la jugada intactas
          return translationMap[p1] + (match.includes('x') ? 'x' : '') + p2
        })
      }
      // Reemplazar los comentarios con la traducción de códigos de piezas
      const translatedText = pgnText.replace(commentRegex, (match) => translateCodesInComment(match))
      return translatedText
    },
    // Función existente para convertir movimientos en notación PGN dentro de un texto
    convertMovesToSpeech (text) {
      // Expresión regular para encontrar movimientos en notación PGN
      const moveRegex = /\b([KQRBNDTAC]?[a-h]?[1-8]?x?[a-h][1-8](=[QRBNDTAC])?[+#]?|O-O(-O)?)(?=\b|[^a-zA-Z0-9])/g

      const pieceNames = {
        K: 'Rey',
        Q: 'Dama',
        R: 'Torre',
        B: 'Alfil',
        N: 'Caballo'
      }

      const pieceNamesSpanish = {
        R: 'Rey',
        D: 'Dama',
        T: 'Torre',
        A: 'Alfil',
        C: 'Caballo'
      }

      const files = { a: 'a', b: 'b', c: 'c', d: 'd', e: 'e', f: 'f', g: 'g', h: 'h' }
      const ranks = { '1': 'uno', '2': 'dos', '3': 'tres', '4': 'cuatro', '5': 'cinco', '6': 'seis', '7': 'siete', '8': 'ocho' }

      // Reemplazar cada movimiento encontrado por su descripción verbal
      const convertedText = text.replace(moveRegex, (move) => {
        let verbalMove = ''

        if (move === 'O-O') {
          verbalMove = 'enroque corto'
        } else if (move === 'O-O-O') {
          verbalMove = 'enroque largo'
        } else {
          let capture = move.includes('x')
          let promotion = move.includes('=')
          let check = move.includes('+')
          let checkmate = move.includes('#')

          // Remover anotaciones de jaque y mate
          move = move.replace(/[+#]/g, '')

          // Manejar promociones
          let promotionPiece = ''
          if (promotion) {
            const parts = move.split('=')
            move = parts[0]
            promotionPiece = parts[1]
          }

          // Identificar pieza (por defecto es peón si no se especifica)
          let piece = ''
          // window.alert(piece)
          if (/[KQRBN]/.test(move[0])) {
            piece = pieceNames[move[0]]
            move = move.slice(1)
          }
          if (/[RDTAC]/.test(move[0])) {
            piece = pieceNamesSpanish[move[0]]
            move = move.slice(1)
          }

          // Manejar especificaciones de origen
          let from = ''
          if (move.length > 2 && !move.startsWith('x')) {
            if (files[move[0]] || ranks[move[0]]) {
              from = move[0]
              move = move.slice(1)
            }
          }

          // Manejar capturas
          if (capture) {
            const parts = move.split('x')
            if (parts[0]) {
              from = parts[0]
            }
            move = parts[1]
          }

          // Obtener destino
          const toFile = files[move[0]]
          const toRank = ranks[move[1]]

          // Construir la descripción verbal
          if (capture) {
            if (from) {
              verbalMove = `${piece} desde ${from} captura en ${toFile} ${toRank}`
            } else {
              verbalMove = `${piece} captura en ${toFile} ${toRank}`
            }
          } else {
            if (from) {
              verbalMove = `${piece} desde ${from} a ${toFile} ${toRank}`
            } else {
              if (piece.length <= 0) {
                verbalMove = `${toFile} ${toRank}`
              } else {
                verbalMove = `${piece} a ${toFile} ${toRank}`
              }
            }
          }

          // Agregar promoción si existe
          if (promotionPiece) {
            verbalMove += ` y se promociona a ${pieceNames[promotionPiece]}`
          }

          // Agregar jaque o mate si aplica
          if (check) {
            verbalMove += ', jaque'
          } else if (checkmate) {
            verbalMove += ', jaque mate'
          }
        }

        return verbalMove
      })

      return convertedText
    },
    // Nueva función para convertir movimientos en notación PGN fuera de <<<>>>
    convertMovesToSpeechOutsideMarkers (text) {
      // Dividir el texto en segmentos fuera y dentro de <<<>>>
      const segments = []
      let lastIndex = 0

      // Expresión regular para encontrar bloques <<<>>>
      const markerRegex = /<<<[\s\S]*?>>>/g
      let match

      while ((match = markerRegex.exec(text)) !== null) {
        // Texto antes del marcador
        if (match.index > lastIndex) {
          segments.push({
            text: text.substring(lastIndex, match.index),
            isInsideMarkers: false
          })
        }
        // Texto dentro del marcador
        segments.push({
          text: match[0],
          isInsideMarkers: true
        })
        lastIndex = match.index + match[0].length
      }

      // Texto después del último marcador
      if (lastIndex < text.length) {
        segments.push({
          text: text.substring(lastIndex),
          isInsideMarkers: false
        })
      }

      // Procesar segmentos
      const processedText = segments.map(segment => {
        if (segment.isInsideMarkers) {
          // Dejar el texto dentro de <<<>>> sin cambios
          return segment.text
        } else {
          // Convertir movimientos en el texto fuera de <<<>>>
          return this.convertMovesToSpeech(segment.text)
        }
      }).join('')

      return processedText
    },
    habilitarBotones () {
      if (document.getElementById('overlay') !== null) {
        document.getElementById('overlay').style.display = 'none'
      }
      const chatQuestion = document.getElementById('aiquestion')
      if (chatQuestion) {
        // window.alert(chatQuestion.value)
        chatQuestion.value = ''
      }
    },
    deshabilitarBotones () {
      if (document.getElementById('overlay') !== null) {
        document.getElementById('overlay').style.display = 'block'
      }
    },
    textToSpeach (text) {
      if (this.isParamOnly === false || true) {
        // clearInterval(this.intervalMouth)
        // this.getMouthShape('a') // Resetear la forma de la boca al final
        /* window.speechSynthesis.cancel()
        this.speech = new SpeechSynthesisUtterance(text)
        const voices = window.speechSynthesis.getVoices()
        for (let i = 0; i < voices.length; i++) {
          if (voices[i].name === this.listaVocesSelected) {
            this.speech.voice = voices[i]
            break
          }
          // window.alert(voices[i].name)
        }
        // Vincular eventos onstart y onend a la instancia de speech
        this.speech.onstart = () => {
          // this.moveHead() // Mover la cabeza al iniciar
          // this.animateMouth(text) // Iniciar animación de la boca
          // this.animateEyes() // Iniciar movimiento de ojos
          // this.animateEyebrows() // Iniciar movimiento de cejas
        }
        this.speech.onend = () => {
          // window.alert('onend')
          // clearInterval(this.intervalMouth)
          // this.getMouthShape('a') // Resetear la forma de la boca al final
        }
          // this.listaVocesFill = this.listaVoces.length
        // const selectedOption =
          // voiceSelect.selectedOptions[0].getAttribute("data-name");
        /* for (let i = 0; i < voices.length; i++) {
          this.listaVoces.push(voices[i])
        }*
          /* if (voices[i].name === selectedOption) {
            utterThis.voice = voices[i];
            break;
          }*
        // }
        // utterThis.pitch = pitch.value
        // utterThis.rate = rate.value
        if (this.varTextToSpeach === true || true) {
          // this.startSpeakingAnimation(text)
          window.speechSynthesis.speak(this.speech)
        }*/
        openai.generateSpeech(this, text, this.listaVocesSelected || 'nova')
          .then(url => {
            if (this.varTextToSpeach === true || true) {
              if (this.audio) {
                this.audio.stop()
                this.audio = null
              }
              this.audio = new Audio(url)
              this.audio.play()
            }
          })
          .catch(error => {
            console.error('Error generating speech: ', error)
          })
      }
    },
    generateText (textArg) {
      try {
        // window.swal(textArg)
        // window.alert(this.user.age)
        openai.generateText(this, textArg, this.pgn, this.user.age).then(data => {
          console.log('Datos recibidos: ', data)
          let textoLimpio = data.choices[0].message.content.replace(/[\n\r\t]/g, ' ')
          textoLimpio = this.translatePieceCodesInComments(textoLimpio)
          // window.alert(JSON.stringify(data.choices[0].message.content))
          const speechContent = this.convertMovesToSpeechOutsideMarkers(textoLimpio)
          this.textToSpeach(speechContent)
          window.swal(textoLimpio)
          this.airesponse = textoLimpio
          const chatContent = document.getElementById('chat-content')
          if (chatContent) {
            chatContent.innerHTML += this.answerUser(textArg)
            this.scrollBottom()
          }
          if (chatContent) {
            chatContent.innerHTML += this.answerIA(this.airesponse)
            this.scrollBottom()
          }
          this.habilitarBotones()
          // Aquí manejas los datos recibidos
        }).catch(error => {
          console.error('Error al generar texto: ', error)
          this.habilitarBotones()
          // Maneja el error aquí
        })
      } catch (error) {
        console.error(`Error: ${error.message}`)
      }
    },
    insertComments () {
      this.airesponse = ''
      // this.deshabilitarBotones()
      // const board = this.generateBoardFromFEN(this.fen)
      this.fen = this.chess.fen()
      var turn = this.getTurnFromFen(this.fen) === 'w' ? 'blancas' : 'negras'
      if (this.stockfish !== null && this.stockfish !== undefined) {
        // this.stockfish = EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
        // var baseTime = 1 * 60
        // var inc = 1
        // var level = (parseFloat(this.board.elo) / 100) - 4
        var skill = 20 // 0 600 --> 10 1600 --> 20 --> 2600
        this.stockfish.reset()
        // this.stockfish.setTime(parseFloat(this.time.white), this.time.incremento)
        this.stockfish.setSkillLevel(skill)
        this.stockfish.setDisplayScore(true)
        // this.stockfish.setOwnBook(false)
        this.stockfish.start()
        this.stockfish.setPlayerColor(turn)
        // this.stockfish.setPlayerColor(this.orientation)
        this.stockfish.setTime(parseFloat(30000), 20)
        // this.stockfish.setDepth(10)
        this.stockfish.setNodes(0)
        // window.alert(this.pgn)
        this.stockfish.prepareMove(this.fen, '', this.PcIngeniesMoveStockfishHelp, 100000, 100000, 0, 0)
      }
    },
    chessToColor (chess) {
      var t = chess.turn()
      var turn = (t === 'w') ? 'white' : 'black'
      this.turn = turn
      return turn
    },
    countDown () {
      if (isNaN(this.timeMove) === false) {
        this.times = this.timeMove
      } else {
        this.times = 120
      }
      clearInterval(timesColor)
      timesColor = setInterval(function () {
        this.times = this.times - 1
        if (this.times <= 0) {
          clearInterval(timesColor)
          this.times = 0
          this.onMove(-1, -1)
          this.mate = false
          this.numMoves = 0
        }
      }.bind(this), 1000)
    },
    pistaNext () {
      this.puzzle.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(this.puzzle.feninit)
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (fen === this.puzzle.feninit) {
          // window.alert(this.puzzle.startPlay)
          break
        }
        this.puzzle.startPlay++
      }
      if (this.puzzle.startPlay > moves.length) {
        this.puzzle.startPlay = 0
      }
      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
        var numGetMove = this.puzzle.startPlay + this.handMoves
        // window.alert(this.puzzle.startPlay + this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
          this.ground.setAutoShapes({
            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            // dest: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            brush: 'green',
            modifiers: { lineWidth: 10 }
          })
        }
      }
    },
    resultadoNext () {
      this.countDown()
      this.puzzle.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(this.puzzle.feninit)
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (fen === this.puzzle.feninit) {
          // window.alert(this.puzzle.startPlay)
          break
        }
        this.puzzle.startPlay++
      }
      if (this.puzzle.startPlay > moves.length) {
        this.puzzle.startPlay = 0
      }
      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
        var numGetMove = this.puzzle.startPlay + this.handMoves
        // window.alert(this.puzzle.startPlay + this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        this.onMove(window.pgnBoardBase.getPgn().getMove(numGetMove).from, window.pgnBoardBase.getPgn().getMove(numGetMove).from)
        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
          this.ground.setAutoShapes({
            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
            dest: window.pgnBoardBase.getPgn().getMove(numGetMove).to,
            brush: 'yellow',
            modifiers: {lineWidth: 5}
          })
        }
      }
    },
    onMoveFinal (orig, dest, promopiece) {
      // window.swal('pieza' + JSON.stringify(promopiece))
      // window.swal('move')
      this.ground.setAutoShapes({
        orig: '-1',
        dest: '-1',
        brush: 'yellow',
        modifiers: {lineWidth: 5}
      })
      this.numMoves --
      this.chess.move({
        from: orig,
        to: dest,
        promotion: promopiece
      })
      this.ground.move(orig, dest)
      this.ground.set({
        fen: this.chess.fen(),
        turnColor: this.chessToColor(this.chess),
        movable: {
          color: this.chessToColor(this.chess),
          dests: this.chessToDests(this.chess)
        },
        animation: {
          enabled: true,
          duration: 600
        },
        highlight: {
          lastMove: true,       // add last-move class to squares
          check: true          // add check class to squares
        },
        drawable: {
          enabled: true,
          visible: true
        }
      })
      this.puzzle.startPlay = 1
      var moves = window.pgnBoardBase.getPgn().getMoves()
      // window.alert(JSON.stringify(moves))
      for (var i = 0; i < moves.length; i++) {
        var fen = moves[i].fen
        if (this.puzzle.feninit !== undefined && fen === this.puzzle.feninit) {
          // window.alert(this.puzzle.startPlay)
          break
        }
        this.puzzle.startPlay++
      }
      if (this.puzzle.startPlay > moves.length) {
        this.puzzle.startPlay = 0
      }
      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0 && !this.puzzle.type.startsWith('Practica')) {
        var numGetMove = this.puzzle.startPlay + this.handMoves
        // window.alert(JSON.stringify(window.pgnBoardBase.getPgn().getMove(numGetMove)))
        // window.alert(this.handMoves)
        // window.alert('.' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation + '.')
        var equal = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation
        if (equal === false) {
          for (var v = 0; v < window.pgnBoardBase.getPgn().getMove(numGetMove).variations.length; v++) {
            equal = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).variations[v].notation.notation
            if (equal === true) {
              // window.alert('variante ' + this.chess.history()[this.handMoves] + ' ' + window.pgnBoardBase.getPgn().getMove(numGetMove).variations[v].notation.notation + '.')
              break
            }
          }
        }
        if (equal === false /* this.chess.history()[this.handMoves] !== window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation*/) {
          // window.alert('pierdes')
          this.numMoves = 0
          this.mate = false
          // this.ground.stop()
          this.resolvePuzzle({_id: this.puzzle._id, resolve: this.mate ? 1 : 0})
          clearInterval(timesColor)
        } else if (this.numMoves <= 0) {
          // window.alert('ganas')
          this.mate = equal// this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation
          // this.ground.stop()
          this.resolvePuzzle({_id: this.puzzle._id, resolve: this.mate ? 1 : 0})
          this.loadPuzzle(this.chess.fen(), false)
          clearInterval(timesColor)
        } else {
          // this.movePC(this.turn)
          orig = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).from
          dest = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).to
          // this.onMove(sfrom, sto)
          this.numMoves --
          this.chess.move({
            from: orig,
            to: dest,
            promotion: promopiece
          })
          this.ground.move(orig, dest)
          this.ground.set({
            fen: this.chess.fen(),
            turnColor: this.chessToColor(this.chess),
            movable: {
              color: this.chessToColor(this.chess),
              dests: this.chessToDests(this.chess)
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            animation: {
              enabled: true,
              duration: 600
            },
            drawable: {
              enabled: true,
              visible: true
            }
          })
          this.loadPuzzle(this.chess.fen(), false)
          this.handMoves++
        }
      } else {
        this.resultPractica = ''
        this.movePC(this.turn)
        this.numMoves = 1
        if (this.isFinish(this.chess)) {
          this.retrocederPosible = false
          clearInterval(timesColor)
          if (this.chess.in_checkmate()) {
            this.resultPractica = 'Jaque mate'
            this.toast('Jaque mate', 2000)
            this.mate = this.chess.turn() === this.turn
          } else if (this.chess.in_draw()) {
            this.toast('Tablas', 2000)
            this.resultPractica = 'Tablas'
          } else {
            this.mate = true
          }
          this.numMoves = 0
        }
        /* if (this.numMoves <= 0) {
          if (true * this.puzzle.type === 'Tactic' || this.puzzle.type === 'Aperturas' || this.puzzle.type === 'Finales' || this.puzzle.type === 'Estrategia'*) {
            // verificar que fen actual es la esperada
            // console.log(this.puzzle.fenfinish, this.ground.getFen())
            // window.alert(this.ground.getFen() + '\n' + this.puzzle.fenfinish.split(' ')[0])
            this.mate = this.puzzle.fenfinish.split(' ')[0] === this.ground.getFen()
          } else {
            this.mate = this.isFinish(this.chess)
          }
          this.ground.stop()
          this.resolvePuzzle({_id: this.puzzle._id, resolve: this.mate ? 1 : 0})
        } else {
          /* var PgnNew = this.puzzle.pgn.split('"]').join('"]\n')
          PgnNew = PgnNew.split('{}').join('')
          // window.alert(PgnNew)
          this.chessPgn.load_pgn(PgnNew)
          // window.alert(this.chessPgn.moves())
          // window.alert(this.chess.history()) *
          this.movePC(this.turn)
          if (this.isFinish(this.chess)) {
            // window.alert('this.isFinish')
          }
        } */
      }
      this.handMoves++
    },
    onMove (orig, dest) {
      // window.alert('onMove')
      let _self = this
      if (this.chess) {
        let turn = this.chess.turn() === 'w' ? 'white' : 'black'
        let piece
        if (_self.chess && _self.chess.get(orig)) {
          piece = _self.chess.get(orig).type
        }
        if (turn === _self.userColor && piece === 'p' && ((dest.substring(1, 2) === '8') || (dest.substring(1, 2) === '1'))) {
          window.swal('¿A que pieza promociona?', {
            buttons: {
              queen: {text: '♕', value: 'q'},
              rook: {text: '♖', value: 'r'},
              bishop: {text: '♝', value: 'b'},
              knight: {text: '♞', value: 'n'}
            }
          }).then(function (result) {
            setTimeout(() => {
              _self.onMoveFinal(orig, dest, result)
            }, 500)
          })
        } else {
          setTimeout(() => {
            this.onMoveFinal(orig, dest, 'q')
          }, 500)
        }
      } else {
        setTimeout(() => {
          this.onMoveFinal(orig, dest, 'q')
        }, 500)
      }
    },
    /* PcIngeniesMove (move) {
      var from = move & 0xFF
      var to = (move >> 8) & 0xFF
      var sfrom = Garbochess.FormatSquare(from)
      var sto = Garbochess.FormatSquare(to)
      this.onMove(sfrom, sto)
    },*/
    PcIngeniesMoveStockfishHelp (move) {
      // var from = move.from
      // var to = move.to
      // window.alert(from + to)
      // this.onMove(from, to)
      setTimeout(() => {
        var sFrom = move.from
        var sTo = move.to
        if (window.ground !== undefined && window.ground !== null) {
          // window.alert(sFrom + ' ' + sTo)
          this.ground.setAutoShapes([{
            orig: sFrom,
            dest: sTo,
            brush: 'green',
            modifiers: {lineWidth: 5}
          }])
        }
      }, 1000)
      if (this.stockfish !== null && this.stockfish !== undefined) {
        // window.alert('Parando motor de evaluación')
        // this.stockfish.close()
        // this.stockfish = null
        // const board = this.generateBoardFromFEN(this.fen)
        var turn = this.getTurnFromFen(this.fen) === 'w' ? 'blancas' : 'negras'
        // window.alert(this.fen + ' ' + this.getIndexFromFen(this.fen) + ' ' + ' ' + turn)
        // El FEN es ${this.fen} y su representacion en el tablero es ${board}.
        var text = `Dame un comentario sobre la posición ${this.getIndexFromFen(this.fen)} del pgn que te adjunto.
          Es el turno de las ${turn}.
          Que movimiento recomiendas, revisa las amenazas en el tablero, pero sobretodo la usa como tuya la recomendación que te paso de un motor de ajedrez.
          Tu respuesta no puede ser mayor a 200 caracteres. La notación algebráica que uses tiene que ser siempre en español, no hace falta que indiques nada del PGN`
        var san = this.moveToSan(move)
        if (san) {
          text += `la recomendación es ${san}. Sigue las indicaciones de la recomendación y usala como si fuera tuya`
        }
        this.generateText(text)
      }
    },
    PcIngeniesMoveStockfish (move) {
      var from = move.from
      var to = move.to
      // window.alert(from)
      this.onMove(from, to)
      this.retrocederPosible = true
    },
    movePC (turn) {
      if (turn !== this.userColor) {
        setTimeout(function () {
          this.pcMove(this.chess.fen())
        }.bind(this), 200)
      }
    },
    pcMove (fen) {
      if (this.stockfish !== null && this.stockfish !== undefined) {
        this.retrocederPosible = false
        this.stockfish.setPlayerColor(this.orientation)
        // var white = parseFloat(this.time.white) * 1000
        // var black = parseFloat(this.time.black) * 1000
        // var incremento = parseFloat(this.time.incremento) * 1000
        // this.stockfish.setTime(1000, 0)
        this.stockfish.setDepth(12)
        this.stockfish.setSkillLevel(20)
        this.stockfish.setNodes(0)
        // this.toast('<span>Deja que piense</span>', 1000)
        this.stockfish.prepareMove(fen, '', this.PcIngeniesMoveStockfish, 1000, 1000, 0, 0)
        /* if (this.puzzle._id) {
          // use chess moves
          // this.makeRandomMove()
          Garbochess.InitializeFromFen(fen)
          Garbochess.Search(this.PcIngeniesMove, 5, null)
        } else {
          // use garbochess ingenie (dando problemas con los flags)
          Garbochess.InitializeFromFen(fen)
          Garbochess.Search(this.PcIngeniesMove, 5, null)
        }*/
      }
    },
    makeRandomMove () {
      // window.alert('makeRandomMove')
      var possibleMoves = this.chess.moves({
        verbose: true
      })
      var randomIndex = Math.floor(Math.random() * possibleMoves.length)
      var move = possibleMoves[randomIndex]
      var from = move.from
      var to = move.to
      this.onMove(from, to)
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    randomSquare (colorParam) {
      let square
      do {
        square = this.chessFind.SQUARES[Math.floor(Math.random() * 64)]
      } while (this.chessFind.get(square) || (this.chessFind.square_color(square) !== colorParam))
      return square
    },
    dosalfiles () {
      if (this.puzzle.titlefen === 'Mate con dos alfiles') {
        while (this.puzzle.pgn === '') {
          this.chessFind.clear()
          this.chessFind.turn('b')
          this.chessFind.put({ type: 'k', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'k', color: 'b' }, this.randomSquare('dark'))
          this.chessFind.put({ type: 'b', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'b', color: 'w' }, this.randomSquare('dark'))
          this.chessFind.load(this.chessFind.fen().replace(' w ', ' b '))
          if (!this.chessFind.game_over() && !this.chessFind.in_draw() && !this.chessFind.in_checkmate() && !this.chessFind.in_check() && !this.chessFind.in_stalemate() && !this.chessFind.in_checkmate()) {
            this.chessFind.load(this.chessFind.fen().replace(' b ', ' w '))
            this.puzzle.pgn = '[SetUp "1"]\r\n[FEN "' + this.chessFind.fen() + '"]'
            break
          }
        }
      } else {
      }
    },
    solotorre () {
      if (this.puzzle.titlefen === 'Mate con una torre') {
        while (this.puzzle.pgn === '') {
          this.chessFind.clear()
          this.chessFind.turn('b')
          this.chessFind.put({ type: 'k', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'k', color: 'b' }, this.randomSquare('dark'))
          this.chessFind.put({ type: 'r', color: 'w' }, this.randomSquare('light'))
          this.chessFind.load(this.chessFind.fen().replace(' w ', ' b '))
          if (!this.chessFind.game_over() && !this.chessFind.in_draw() && !this.chessFind.in_checkmate() && !this.chessFind.in_check() && !this.chessFind.in_stalemate() && !this.chessFind.in_checkmate()) {
            this.chessFind.load(this.chessFind.fen().replace(' b ', ' w '))
            this.puzzle.pgn = '[SetUp "1"]\r\n[FEN "' + this.chessFind.fen() + '"]'
            break
          }
        }
      } else {
      }
    },
    solodama () {
      if (this.puzzle.titlefen === 'Mate con una dama') {
        while (this.puzzle.pgn === '') {
          this.chessFind.clear()
          this.chessFind.turn('b')
          this.chessFind.put({ type: 'k', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'k', color: 'b' }, this.randomSquare('dark'))
          this.chessFind.put({ type: 'q', color: 'w' }, this.randomSquare('light'))
          this.chessFind.load(this.chessFind.fen().replace(' w ', ' b '))
          if (!this.chessFind.game_over() && !this.chessFind.in_draw() && !this.chessFind.in_checkmate() && !this.chessFind.in_check() && !this.chessFind.in_stalemate() && !this.chessFind.in_checkmate()) {
            this.chessFind.load(this.chessFind.fen().replace(' b ', ' w '))
            this.puzzle.pgn = '[SetUp "1"]\r\n[FEN "' + this.chessFind.fen() + '"]'
            break
          }
        }
      } else {
      }
    },
    dostorres () {
      if (this.puzzle.titlefen === 'Mate con dos torres') {
        this.puzzle.pgn = ''
        do {
          this.chessFind.clear()
          this.chessFind.turn('b')
          this.chessFind.put({ type: 'k', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'k', color: 'b' }, this.randomSquare('dark'))
          this.chessFind.put({ type: 'r', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'r', color: 'w' }, this.randomSquare('dark'))
          this.chessFind.load(this.chessFind.fen().replace(' w ', ' b '))
          if (!this.chessFind.game_over() && !this.chessFind.in_draw() && !this.chessFind.in_checkmate() && !this.chessFind.in_check() && !this.chessFind.in_stalemate() && !this.chessFind.in_checkmate()) {
            this.chessFind.load(this.chessFind.fen().replace(' b ', ' w '))
            this.puzzle.pgn = '[SetUp "1"]\r\n[FEN "' + this.chessFind.fen().replace(' b ', ' w ') + '"]'
          }
        } while (this.puzzle.pgn === '')
      } else {
      }
    },
    alfilycaballo () {
      if (this.puzzle.titlefen === 'Mate con alfil y caballo') {
        while (this.puzzle.pgn === '') {
          this.chessFind.clear()
          this.chessFind.turn('b')
          this.chessFind.put({ type: 'k', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'k', color: 'b' }, this.randomSquare('dark'))
          this.chessFind.put({ type: 'b', color: 'w' }, this.randomSquare('light'))
          this.chessFind.put({ type: 'n', color: 'w' }, this.randomSquare('dark'))
          this.chessFind.load(this.chessFind.fen().replace(' w ', ' b '))
          if (!this.chessFind.game_over() && !this.chessFind.in_draw() && !this.chessFind.in_checkmate() && !this.chessFind.in_check() && !this.chessFind.in_stalemate() && !this.chessFind.in_checkmate()) {
            this.chessFind.load(this.chessFind.fen().replace(' b ', ' w '))
            this.puzzle.pgn = '[SetUp "1"]\r\n[FEN "' + this.chessFind.fen() + '"]'
            break
          }
        }
      } else {
      }
    },
    loadPuzzle (fen, init) {
      // window.alert(this.puzzle.titlefen)
      // Array de PGNs para ejercicios de mate con alfil y caballo
      this.puzzle.pgn = ''
      this.alfilycaballo()
      this.dostorres()
      this.dosalfiles()
      this.solotorre()
      this.solodama()
      try {
        if (init === true) {
          if (this.puzzle.timemove === undefined) {
            this.puzzle.timemove = 120
          }
          if (this.puzzle.nummoves === undefined) {
            this.puzzle.nummoves = 1
          }
          this.numMoves = parseInt(this.puzzle.nummoves) // (parseInt(this.puzzle.nummoves) * 2) - 1
          this.timeMove = parseInt(this.puzzle.timemove) // (parseInt(this.puzzle.nummoves) * 2) - 1
          // window.alert(this.puzzle.titlefen)
          this.titlefen = this.puzzle.titlefen
          this.handMoves = 0
        }
        if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
          var Width = 500
          if (document.getElementById('puzzleBoard') !== undefined) {
            Width = document.getElementById('puzzleBoard').clientWidth
          }
          var pgnBoard = 0
          var pos = 'end'
          var start = fen !== undefined ? fen : ''
          if (init === true) {
            this.puzzle.pgn = this.puzzle.pgn.split('"]').join('"]\n')
            this.puzzle.pgn = this.puzzle.pgn.split('{}').join('')
          }
          var headers = this.parse_pgn_header(this.puzzle.pgn)
          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
            pos = fen !== undefined ? fen : 'end'
            if (!this.hasBody(this.puzzle.pgn)) {
              start = ''
              pos = headers['FEN']
            }
            if (pos === headers['FEN']) {
              start = ''
            }
          }
          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
            start = ''
            pos = fen
          }
          if (fen === headers['FEN']) {
            pos = headers['FEN']
          }
          if (document.getElementById('pgnComment')) {
            document.getElementById('pgnComment').textContent = ''
          }
          // var winWidth = Math.min(window.innerWidth, window.outerWidth)
          pgnBoard = window.pgnEdit({inner: 'puzzleBoard', comment: 'pgnComment'}, {pgn: this.puzzle.pgn, position: pos, startPlay: start, width: Width, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: true, headers: true})
          this.ground = pgnBoard.board
          if (init === true) {
            this.chess = pgnBoard.chess
          }
          window.pgnBoardBase = pgnBoard.boardBase
          if (document.getElementById('puzzleBoard') !== undefined) {
            document.getElementById('puzzleBoard').style.height = Width + 'px'
            document.getElementById('puzzleBoard').style.width = Width + 'px'
          }
          if (init === true) {
            this.userColor = this.chess.turn() === 'w' ? 'white' : 'black'
            this.orientation = this.userColor
          }
          var options = {
            orientation: this.orientation,
            movable: {
              free: false,
              color: 'both',
              dests: this.chessToDests(this.chess),
              dropOff: 'revert',
              showDests: true,
              events: {
                after: this.onMove
              }
            },
            animation: {
              enabled: true,
              duration: 600
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          }
          // window.alert(pgnBoard.boardBase.getPgn().write_pgn())
          // window.alert(JSON.stringify(pgnBoard.boardBase.getPgn().getMove(0)))
          this.ground.set(options)
          this.chessToColor(this.chess)
          // this.movePC(this.turn)
        } else {
          if (fen) {
            this.chess.load(fen/* + ' ' + 'w KQ - 21 20'*/)
          } else {
            this.chess.load('8/2k5/8/8/6P1/8/8/4K3 w - - 0 1')
          }
          this.userColor = this.chess.turn() === 'w' ? 'white' : 'black'
          this.orientation = this.userColor
          // window.alert(this.userColor)
          this.ground.set({
            orientation: this.orientation,
            fen: this.chess.fen(),
            turnColor: this.chessToColor(this.chess),
            movable: {
              color: this.chessToColor(this.chess),
              dests: this.chessToDests(this.chess),
              events: {
                after: this.onMove
              }
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            animation: {
              enabled: true,
              duration: 600
            },
            drawable: {
              enabled: true,
              visible: true
            }
          })
          this.movePC(this.turn)
        }
        this.countDown()
        const comments = document.querySelectorAll('.afterComment')
        comments.forEach((comment) => {
          // Verifica si el texto del comentario contiene el emoji 🎥
          const textResource = comment.textContent.toLowerCase()
          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
            // Añade la clase .highlight-move al elemento padre con clase .move
            comment.closest('.move').classList.add('highlight-move')
          }
        })
      } catch (error) {
        // this.toast('<span>' + 'Error LoadPuzzle: ' + error + '</span>', 3000)
        console.error('<span>' + 'Error LoadPuzzle: ' + error + '</span>', 3000)
      }
    },
    resultado () {
      this.resultadoNext()
    },
    pista () {
      this.pistaNext()
    },
    isFinish (chess) {
      // clearInterval(timesColor)
      return chess.game_over()
    },
    reintent () {
      clearInterval(timesColor)
      this.mate = false
      this.loadPuzzle(this.puzzle.feninit, true)
    }
  },
  destroyed () {
    // window.alert('Parando motor de evaluación')
    if (this.stockfish !== null && this.stockfish !== undefined) {
      this.stockfish.close()
      this.stockfish = null
    }
  },
  beforeDestroy () {
    // window.alert('Parando motor de evaluación')
    if (this.stockfish !== null && this.stockfish !== undefined) {
      this.stockfish.close()
      this.stockfish = null
    }
  },
  ready () {
    // window.alert('READY')
    try {
      // Garbochess.ResetGame()
      // this.stockfish = EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
      // var baseTime = 1 * 60
      // var inc = 1
      // var level = (parseFloat(this.board.elo) / 100) - 4
      // window.alert('Nivel ' + level)
      var skill = 20 // 0 600 --> 10 1600 --> 20 --> 2600
      // window.alert(this.stockfish)
      if (this.stockfish == null || this.stockfish === undefined) {
        this.stockfish = EngineGame.engineGame({book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js'})
      }
      // window.alert(this.stockfish)
      if (this.stockfish !== null && this.stockfish !== undefined) {
        this.stockfish.reset()
        // this.stockfish.setTime(parseFloat(this.time.white), this.time.incremento)
        this.stockfish.setSkillLevel(skill)
        this.stockfish.setDepth(12)
        this.stockfish.setPlayerColor(this.orientation)
        this.stockfish.setDisplayScore(true)
        this.stockfish.setOwnBook(false)
        this.stockfish.start()
      }
      window.addEventListener('resize', this.onResize)
      // window.alert(classBoard)
      setTimeout(function () {
        // this.ground = Chessground(document.getElementById('puzzleBoard'), options)
        var pgnBoard = 0
        // window.alert(this.pgn)
        // var PgnNew = this.puzzle.pgn.split('"]').join('"]\n')
        // PgnNew = PgnNew.split('{}').join('')
        // window.alert(PgnNew)
        if (document.getElementById('pgnComment')) {
          document.getElementById('pgnComment').textContent = ''
        }
        // var winWidth = Math.min(window.innerWidth, window.outerWidth)
        pgnBoard = window.pgnEdit({inner: 'puzzleBoard', comment: 'pgnComment'}, {showCoords: true, width: Width, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: true, headers: true})
        if (pgnBoard.board !== undefined && pgnBoard.board !== null) {
          this.ground = pgnBoard.board
          window.pgnBoardBase = pgnBoard.boardBase
          // window.alert(pgnBoard.chess.color())
          var options = {
            orientation: 'white',
            movable: {
              free: false,
              color: 'both',
              dests: this.chessToDests(this.chess),
              dropOff: 'revert',
              showDests: true,
              events: {
                after: this.onMove
              }
            },
            animation: {
              enabled: true,
              duration: 600
            },
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            drawable: {
              enabled: true,
              visible: true
            }
          }
          this.ground.set(options)
          if (document.getElementById('puzzleBoard')) {
            var Width = document.getElementById('puzzleBoard').clientWidth - 20
            if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
              Width = Width - 35
            }
            document.getElementById('puzzleBoard').style.height = Width + 'px'
            document.getElementById('puzzleBoard').style.width = Width + 'px'
          }
          // getFromLocalStorage
          // console.log('cargando board')
          this.loadPuzzle('', true)
        }
        const comments = document.querySelectorAll('.afterComment')
        comments.forEach((comment) => {
          // Verifica si el texto del comentario contiene el emoji 🎥
          const textResource = comment.textContent.toLowerCase()
          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
            // Añade la clase .highlight-move al elemento padre con clase .move
            comment.closest('.move').classList.add('highlight-move')
          }
        })
      }.bind(this), 10)
    } catch (error) {
      // this.toast('<span>' + 'Error (ready puzzle): ' + error + '</span>', 3000)
      console.error('<span>' + 'Error (ready puzzle): ' + error + '</span>', 3000)
    }
  },
  watch: {
    puzzle (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadPuzzle(newVal.feninit, true)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/libs/simplechessboard.min.css';
h1 {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// puzzle.vue?5dfa4249